import queryString from 'query-string'
import { actions as steamActions } from '../features/Steam'

export default function validateSteam(store) {
    const query = queryString.parse(document.location.search)
    const ticket = query.steam_ticket

    // Look for the steam_ticket query parameter, and if it contains
    // any text we assume it as a steam launch.
    // Then store the steam values in the store
    const steam = {
        steamStartup: ticket !== undefined,
        ticket,
        hasLoggedIn: false,
    }

    if (store !== undefined) {
        // Update the steam data
        store.dispatch(steamActions.updateSteam(steam))
    }
}



// WEBPACK FOOTER //
// ./src/store/steam-validation.js